module.exports = __webpack_public_path__ + "img/Founder_Logo.03ce7408.jpg";